/* E-CATALOGO 18/10/2026. Le schede col mondo nelle griglie (snippets/product-card.liquid): davanti la tavola del mondo, dietro la foto del
   capo. La foto del capo non si scarica con la prima schermata.
   Dal computer col mouse: si scarica dopo il caricamento quando la scheda è vicina allo schermo, e si vede al passaggio del mouse (CSS del tema).
   Al telefono: dopo il primo scorrimento si scarica quando la scheda è vicina, e si vede quando la scheda sale nella metà alta dello schermo;
   tornando giù si rivede la tavola. Il file si può chiamare più volte (una per scheda col mondo), lavora una volta sola. */
(function () {
  if (window.__bhCat) return;
  window.__bhCat = 1;
  var d = document, armato = false, viste = new WeakSet(), attesa = 0;
  var mouse = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 993px)');
  function carica(a) {
    var i = a.querySelector('img[data-bh-cat-srcset]');
    if (!i) return;
    i.setAttribute('srcset', i.getAttribute('data-bh-cat-srcset'));
    i.setAttribute('src', i.getAttribute('data-bh-cat-src'));
    i.removeAttribute('data-bh-cat-srcset');
  }
  var vicino = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting && (armato || mouse.matches)) { carica(e.target); vicino.unobserve(e.target); }
    });
  }, { rootMargin: '400px 0px' });
  var alto = new IntersectionObserver(function (es) {
    if (!armato || mouse.matches) return;
    es.forEach(function (e) {
      var a = e.target;
      if (e.isIntersecting) a.classList.add('bh-cat--capo');
      else if (e.boundingClientRect.top > 0) a.classList.remove('bh-cat--capo');
    });
  }, { rootMargin: '0px 0px -55% 0px' });
  function guarda() {
    attesa = 0;
    d.querySelectorAll('a.bh-cat').forEach(function (a) {
      if (viste.has(a)) return;
      viste.add(a); vicino.observe(a); alto.observe(a);
    });
  }
  function arma() {
    if (armato || window.scrollY < 40) return;
    armato = true;
    window.removeEventListener('scroll', arma);
    d.querySelectorAll('a.bh-cat').forEach(function (a) {
      if (!viste.has(a)) return;
      vicino.unobserve(a); vicino.observe(a); alto.unobserve(a); alto.observe(a);
    });
  }
  d.addEventListener('click', segna, true);
  d.addEventListener('mouseover', segna, true);
  function segna(ev) {
    var v = ev.target.closest && ev.target.closest('.product-card__variant-item');
    if (!v) return;
    if (ev.type === 'mouseover' && window.innerWidth < 993) return;
    var c = v.closest('.product-card');
    if (c && c.querySelector('a.bh-cat')) c.classList.add('bh-cat--scelto');
  }
  function parti() {
    guarda();
    window.addEventListener('scroll', arma, { passive: true });
    new MutationObserver(function () { if (!attesa) attesa = setTimeout(guarda, 300); }).observe(d.body, { childList: true, subtree: true });
  }
  if (d.readyState === 'complete') parti(); else window.addEventListener('load', parti);
})();
